// extracted by mini-css-extract-plugin
export default {"component":"FirstPage_component__7cBKR","userPhoto":"FirstPage_userPhoto__9jzKx"};